@if (errorControl() != null && errorControl().invalid && (errorControl().dirty || (errorControl().touched && touched()))) {
  <div class="errorMessage">
    <ng-content />
  </div>
}